import { Switch } from '@thanx/uikit/switch'
import { defaultTheme, useStyletron } from '@thanx/uikit/theme'
import React from 'react'
import Nav from 'react-bootstrap-five/Nav'
import { history } from 'store'

type TabProps = {
  tabKey: string
  name: string
  active: boolean
  children?: React.ReactNode
}

const Tab: React.FC<TabProps> = ({ tabKey, name, active, children }) => {
  const [css] = useStyletron()

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault()
    if (tabKey === 'app_navigation') {
      // Navigate to the app navigation standalone page (default to style)
      history.push('/brand_content/app_navigation')
    } else {
      // Navigate to regular content with hash
      history.push(`/brand_content#${tabKey}`)
    }
  }
  // If there are children (subtabs), render TabGroup structure
  if (children) {
    const isGroupActive = active

    return (
      <div className="overflow-hidden border-radius-5">
        <Nav.Item>
          <Nav.Link
            onClick={handleClick}
            className={`pl-m body-text-4 ${
              isGroupActive ? 'grey-90 bold belize-hole-10-bkg' : 'grey-70'
            } ${css({
              ':focus': {
                color: defaultTheme.colors.grey90,
              },
              cursor: 'pointer',
            })}`}
          >
            {name}
          </Nav.Link>
        </Nav.Item>
        <Switch condition={isGroupActive}>
          <div className="belize-hole-10-bkg">{children}</div>
        </Switch>
      </div>
    )
  }

  // Otherwise, render as a simple tab item
  return (
    <Nav.Item>
      <Nav.Link
        onClick={handleClick}
        className={`px-m border-radius-5 body-text-4 ${
          active ? 'grey-90 bold belize-hole-10-bkg' : 'grey-70'
        } ${css({
          ':focus': {
            color: defaultTheme.colors.grey90,
          },
          cursor: 'pointer',
        })}`}
      >
        {name}
      </Nav.Link>
    </Nav.Item>
  )
}

export default Tab
